import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '../../../Context/MobileContext';
import IconLayout from '../IconLayout';
import StatLink from '../StatLink';
import StatNumber from '../StatNumber';
import StatIcon from '../StatIcon';
import StatTooltip from '../StatTooltip';
import s from './Stat.scss';
export var SplitStatLayout = function (_a) {
    var name = _a.name, title = _a.title, value = _a.value, _b = _a.tooltip, tooltip = _b === void 0 ? {} : _b, icon = _a.icon, isActive = _a.isActive, isDisabled = _a.isDisabled, link = _a.link, onClick = _a.onClick, biEventData = _a.biEventData, hasValue = _a.hasValue, id = _a.id, dataHook = _a.dataHook;
    var isMobile = useContext(MobileContext);
    var statLink = (React.createElement(StatLink, { id: id, link: link, onClick: onClick, biEventData: biEventData },
        React.createElement(StatIcon, { icon: icon, isActive: isActive, isDisabled: isDisabled })));
    var statNumber = (React.createElement(StatNumber, { value: value, isValueClickable: tooltip && !!tooltip.renderPopover }));
    return (React.createElement(IconLayout, { title: isMobile && (title || statNumber), className: classnames(s['root'], name && s["stat-" + name], isMobile && s['no-hover-effect']) },
        React.createElement("span", { className: s['stat'], "data-hook": dataHook }, isMobile ? (statLink) : (React.createElement(React.Fragment, null,
            React.createElement(StatTooltip, { tooltipKey: tooltip.tooltipKey }, statLink),
            React.createElement(StatTooltip, { renderPopover: tooltip.renderPopover, positionOnly: tooltip.positionOnly }, statNumber))))));
};
SplitStatLayout.displayName = 'SplitStatLayout';
export default SplitStatLayout;
//# sourceMappingURL=SplitStatLayout.js.map